const STORAGE_KEY = "linr-app-data";
const LEGACY_STORAGE_KEY = "timeline-app-data";

const DEFAULT_DATA = {
  timelines: [
    {
      id: "default",
      name: "Untitled",
      events: [],
    },
  ],
  activeTimelineId: "default",
};

export function loadData() {
  try {
    let raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      raw = localStorage.getItem(LEGACY_STORAGE_KEY);
      if (raw) {
        localStorage.setItem(STORAGE_KEY, raw);
      }
    }
    if (!raw) return { ...DEFAULT_DATA, timelines: [{ ...DEFAULT_DATA.timelines[0], events: [] }] };
    const data = JSON.parse(raw);
    return {
      timelines: data.timelines || [],
      activeTimelineId: data.activeTimelineId || data.timelines?.[0]?.id || "default",
      orientation: data.orientation || "vertical",
    };
  } catch {
    return { ...DEFAULT_DATA, timelines: [{ ...DEFAULT_DATA.timelines[0], events: [] }] };
  }
}

export function saveData(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // localStorage full or unavailable
  }
}

export function exportToJSON(data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `linr-export-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export function importFromJSON(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        if (!data.timelines || !Array.isArray(data.timelines)) {
          throw new Error("Invalid format: missing timelines array");
        }
        resolve(data);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsText(file);
  });
}
